import React, { useState } from "react";
import { Link } from "react-router-dom";

interface ILeaderDetails {
  name: string;
  role: string;
  description: string;
  linkedin: string;
  image: string;
}

const LeadershipTeam: React.FC = () => {
  const leadersDetails: ILeaderDetails[] = [
    {
      name: "Sandeep Soni",
      role: "Chief Managing Director",
      description:
        "Sandeep Soni, the dynamic and charismatic Chairman and Managing Director (CMD) of Dream Weavers Group, brings extensive experience and expertise to the organization. A Master's degree holder in Business Administration, he is the driving force behind the company's vision and success. Mr. Soni's leadership is marked by strategic foresight, analytical acumen, and practical decision-making. His ability to simplify complex problems and communicate solutions effectively has played a key role in elevating Dream Weavers Group to new heights. His calm yet confident personality inspires those around him and fosters a culture of trust and progress.He is known for making timely, strategic decisions that support long-term organizational growth. His balanced perspective — drawn from both global and local business experiences — enhances the practicality and depth of his leadership. Mr. Soni's integrity, clarity, and pragmatic approach are evident in every initiative he undertakes, shaping the company's present and future with purpose.",
      linkedin: "http://linkedin.com/in/sandeep-soni-6b769110",
      image: "/company/leadership/sandeep-soni.png",
    },
    {
      name: "Niti Soni",
      role: "Joint Managing Director and Founder",
      description:
        "Niti Soni, co-founder and Joint Managing Director of Dream Weavers Group, played a pivotal role in naming and shaping the organization. Her journey stands as a testament to women entrepreneurs who have transformed vision into impactful execution.Armed with an MBA in Marketing and Finance, Niti Soni brings a powerful blend of business acumen and entrepreneurial spirit. Her strategic thinking and problem-solving abilities have led to innovative HR and financial solutions that support the company's mission. As Director (HR & Finance), her involvement spans across all key organizational strategies.She is also an accomplished author in the field of business management and organizational behavior. Her ability to translate traditional models into modern frameworks — especially by integrating finance and human resource insights — has strengthened Dream Weavers' financial and talent strategies.Her nurturing leadership has guided Dream Weavers through its foundational years. She has been instrumental in building visionary processes using her core expertise in business, HR, and performance management — ensuring continued organizational growth and success.",
      linkedin: "http://linkedin.com/in/niti-soni-3b47051a1",
      image: "/company/leadership/niti-soni.png",
    },
    {
      name: "Harish Ratnani",
      role: "Director",
      description:
        "Harish Ratnani, Director at Dream Weavers Group, is a renowned figure in motivational and corporate training. His impactful sessions inspire lifelong learning, team building, creativity, and organizational development across various industries and non-profits.With over a decade of corporate experience, Mr. Ratnani has held significant positions in sales, training, and marketing across the insurance and IT sectors. Starting his career in software sales at Akosaa Distribution Systems, he later joined ICICI Prudential and ING Vysya Life Insurance, where he led multiple training departments across regions.At Dream Weavers Group, Mr. Ratnani spearheads the development of training delivery strategies and communication programs. His practical training philosophy emphasizes how to effectively deliver content and engage learners at all levels.He also holds professional certifications in insurance and financial services, including LIMRA certification as an MSS Trainer. Currently, he leads Dream Weavers' learning and skilling initiatives, including the flagship Learnweaves project, with a focus on impactful execution and measurable success.",
      linkedin: "http://linkedin.com/in/harish-ratnani-78013515",
      image: "/company/leadership/harish-ratnani.png",
    },
    {
      name: "Vivek Sama",
      role: "Global Business Director",
      description:
        "Vivek Sama, Director at Dream Weavers Group, is a trailblazer known for his fearless approach to new ventures and his persuasive communication skills. With a strong background in recruitment, HR consulting, and marketing, he is regarded as a top recruitment strategist across North and West India.Mr. Sama began his career at Tata Infotech Ltd. and went on to work with GlaxoSmithKline as a project officer. Over the years, he has managed large teams and recruitment projects across sectors such as banking, insurance, real estate, and financial services. His reputation as a “trouble-shooter” in recruitment makes him a valuable asset to Dream Weavers.He also serves as Marketing Director for DreamTel (a telecom division of DWG), where he oversees branding, marketing strategy, competitor analysis, campaign development, and budget management — ensuring effective execution across business units.",
      linkedin: "http://linkedin.com/in/vivek-sama-a73809b",
      image: "/company/leadership/vivek-sama.png",
    },
  ];

  return (
    <div>
      <div className="flex justify-start mb-5">
        <div className="flex justify-center w-full md:justify-start">
          <div className="w-full max-w-[14rem] sm:max-w-[18rem] md:max-w-[19rem] lg:max-w-[20rem] sm:ml-[3rem] xl:max-w-[40rem] md:ml-[30px]">
            <h3 className="font-light pb-1 xl:pb-5 xl:pb-50 text-center md:text-left text-2xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-6xl text-[#182152]">
              Leadership Team
            </h3>
            <div className="w-full p-[0.75px] bg-[#FE4329FC]" />
          </div>
        </div>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-5 xl:pt-7 xl:px-10">
        {leadersDetails.map((leader) => {
          return (
            // todo: change key from description id needed
            <div
              className="w-full flex justify-center items"
              key={leader.description}
            >
              <LeaderCard
                name={leader.name}
                role={leader.role}
                linkedin={leader.linkedin}
                description={leader.description}
                image={leader.image}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

const LeaderCard = ({
  name,
  role,
  linkedin,
  description,
  image,
}: ILeaderDetails) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const maxLength = 100;
  const shouldTruncate = description.length > maxLength;
  const displayText = isExpanded ? description : description.slice(0, maxLength);

  return (
    <div className="flex flex-col max-w-72 bg-white">
      <img src={image} alt="" className="h-42" />
      <div className="space-y-1 p-3 border border-t-0">
        <h4 className="font-bold">{name}</h4>
        <h5 className="font-light text-sm">{role}</h5>
        <div>
          <p className="text-[#5F6980] text-xs">
            {displayText}
            {shouldTruncate && !isExpanded && '...'}
          </p>
          {shouldTruncate && (
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="text-blue-600 text-xs mt-1 hover:underline focus:outline-none"
            >
              {isExpanded ? 'Read less' : 'Read more'}
            </button>
          )}
        </div>
        <div className="flex gap-3 pt-3">
          <Link to={linkedin} target="_blank">
            <img src="/company/linkedin.svg" alt="" className="w-6" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LeadershipTeam;
